module.exports = __webpack_public_path__ + "static/media/koryu_00002p.e04f5f5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/koryu_00002p.png
// module id = 205
// module chunks = 0